import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { ImageLibraryComponent } from './image-library/image-library.component';
import { PackagingSearchComponent } from './packaging-instruction-search/packaging-instruction-search.component';
import { DistributionUnitComponent } from './distribution-unit/distribution-unit.component';
import { PackagingCodeComponent } from './packaging-code/packaging-code.component';
import { PackagingMaterialComponent } from './packaging-material/packaging-material.component';
import { PendingChangesGuard } from '../app/shared/page.pendingchangesguard';
import { PackagingMaterialSearchComponent } from './packaging-material-search/packaging-material-search.component';
import { DistributionUnitSearchComponent } from './distribution-unit-search/distribution-unit-search.component';
import { PackagingMaterialAttributeComponent } from './packaging-material-attributes/packaging-material-attributes.component';
import { SupplierContactComponent } from './supplier-contact/supplier-contact.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { MultiPartComponent } from './multipart-part/multipart-part.component';
import { PackagingInstructionComponent } from './packaging-instruction/packaging-instruction.component';
import { ChangeIssuerComponent } from './change-issuer/change-issuer.component';
import { AuthGuard } from './authentication-wam/authguard.service';
import { SequenceInstructionComponent } from './sequence-instruction/sequence-instruction.component';
import { AddMultiplePartsComponent } from './add-multiple-parts/add-multiple-parts.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { NorolepageComponent } from './norolepage/norolepage.component';
import { NorolechinapageComponent } from './norolechinapage/norolechinapage.component';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: '/welcome',
        pathMatch: 'full'
    },
    {
        path: 'welcome',
        component: WelcomeComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: [ "SCANIA_USER", "TEST_PACKER", "PURCHASER", "DEVELOPER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "PART_SUPPLIER_USER", ]
        }
},
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: [ "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PART_SUPPLIER_USER", "DEVELOPER"]
        }
    },
    {
        path: 'distribution_unit',
        component: DistributionUnitComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: [ "SCANIA_USER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
        }
    },
    {
        path: 'distribution_unit/:duId',
        component: DistributionUnitComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: [ "SCANIA_USER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
        }
    },
   {
        path: 'packaging_instruction',
        component: PackagingInstructionComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
        }
    },
    {
        path: 'packaging_instruction/:packInstructionId',
        component: PackagingInstructionComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
        }
    },
    {
        path: 'sequence_instruction/:seqInstructionId',
        component: SequenceInstructionComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
        }
    },
    {
        path: 'image_library',
        component: ImageLibraryComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "DEVELOPER"]
        }
    },
    {
        path: 'packaging_instruction_search',
        component: PackagingSearchComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER"]
        }
    },
    {
        path: 'distribution_unit_search',
        component: DistributionUnitSearchComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
        }
    },
    {
        path: 'packaging_material_search',
        component: PackagingMaterialSearchComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER"]
        }
     },
     {
         path: 'packaging_code',
         component: PackagingCodeComponent,
         canActivate: [AuthGuard],
         canDeactivate: [PendingChangesGuard],
         data: {
             roles: ["SCANIA_USER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER"]
         }
     },
     {
         path: 'packaging_code/:codeId',
         component: PackagingCodeComponent,
         canActivate: [AuthGuard],
         canDeactivate: [PendingChangesGuard],
         data: {
             roles: ["PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "DEVELOPER"]
         }
     },
    {
        path: 'packaging_material',
        component: PackagingMaterialComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "PART_SUPPLIER_USER", "TEST_PACKER", "PURCHASER", "DEVELOPER"]
        }
    },
    {
        path: 'packaging_material/:materialId',
        component: PackagingMaterialComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "PART_SUPPLIER_USER", "TEST_PACKER", "PURCHASER",  "DEVELOPER"]
        }
    },
    {
        path: 'packaging_material_attributes',
        component: PackagingMaterialAttributeComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "DEVELOPER"]
        }
    },
    {
        path: 'supplier_contact',
        component: SupplierContactComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "DEVELOPER", "PART_SUPPLIER_USER"]
        }
    },
    {
        path: 'supplier_contact',
        component: SupplierContactComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "DEVELOPER", "PART_SUPPLIER_USER"]
        }
    },
    {
        path: 'supplier_contact/:supplierNo',
        component: SupplierContactComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "DEVELOPER", "PART_SUPPLIER_USER"]
        }
    },
    {
        path: 'multipart_part',
        component: MultiPartComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "DEVELOPER"]
        }
    },
    {
       path: 'user_management',
       component: UserManagementComponent,
       canActivate: [AuthGuard],
       canDeactivate: [PendingChangesGuard],
       data: {
           roles: ["PACKAGING_ADMINISTRATOR", "DEVELOPER"]
       }
    },
    {
        path: 'change_issuer',
        component: ChangeIssuerComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["PACKAGING_ADMINISTRATOR", "DEVELOPER"]
        }

    },
    {
      path: 'sequence_instruction',
      component: SequenceInstructionComponent,
      canActivate: [AuthGuard],
      canDeactivate: [PendingChangesGuard],
      data: {
          roles: ["SCANIA_USER", "PACKAGING_ENGINEER", "PACKAGING_ADMINISTRATOR", "TEST_PACKER", "PURCHASER", "PART_SUPPLIER_USER", "DEVELOPER" ]
      }
    },{
        path: 'privacy',
        component: PrivacyComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["SCANIA_USER", "PACKAGING_ADMINISTRATOR", "PACKAGING_ENGINEER", "PART_SUPPLIER_USER", "TEST_PACKER", "PURCHASER",  "DEVELOPER"]
        }
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path:'norolepage',
        component: NorolepageComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["NO_ROLE_USER" ]
        }
    },
    {
        path:'norolechinapage',
        component: NorolechinapageComponent,
        canActivate: [AuthGuard],
        canDeactivate: [PendingChangesGuard],
        data: {
            roles: ["NO_ROLE_CHINA_USER" ]
        }
    }
];

@NgModule({
    imports: [ RouterModule.forRoot(appRoutes) ],
    exports: [ RouterModule ],
    providers: [AuthGuard, PendingChangesGuard ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/app-routing.module.ts